import axios from "axios";
import { toast } from "sonner";
import { openPaystackCheckout } from "@/utils/paystackCheckout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Laundry washing bill → Paystack checkout (MoMo or card) in the slide-up sheet.
export async function payLaundryBill(orderId, token) {
  try {
    const { data } = await axios.post(`${API}/laundry/orders/${orderId}/paystack/init?token=${token}`, {
      callback_url: `${window.location.origin}/customer/payment/callback?type=laundry_bill`,
    });
    openPaystackCheckout(data.authorization_url);
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Couldn't start the payment");
    return false;
  }
}
